if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        //this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cart = document.querySelector('mini-cart');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // Add click listener for direct checkout - this runs BEFORE form submission
        // Using capture phase (true) to ensure this runs before other event listeners
        this.submitButton.addEventListener('click', this.onButtonClick.bind(this), { capture: true });
      }

      onButtonClick(evt) {
        console.log('🚨 PRODUCT FORM: onButtonClick called!', {
          event: evt,
          defaultPrevented: evt.defaultPrevented,
          target: evt.target,
          currentTarget: evt.currentTarget
        });
        
        const directCheckout = this.dataset.directCheckout === 'true';
        console.log('Button clicked - Direct checkout enabled:', directCheckout);
        
        if (directCheckout) {
          console.log('Direct checkout: intercepting button click before form submission');
          
          // Completely prevent the button click from doing anything else
          evt.preventDefault();
          evt.stopImmediatePropagation();
          
          // Validate required fields first
          if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) return;
          
          // Get form data
          const formData = new FormData(this.form);
          const variantId = formData.get('id');
          const quantity = formData.get('quantity') || 1;
          
          // Check if addon checkbox is checked
          const addonCheckbox = document.getElementById('addon-checkbox');
          const addonBlock = document.querySelector('[data-addon-block]');
          
          // Disable button to prevent double clicks
          this.submitButton.setAttribute('disabled', true);
          this.submitButton.textContent = 'Redirecting...';
          
          // Prepare cart items
          let cartItems;
          
          if (addonCheckbox && addonCheckbox.checked && addonBlock) {
            console.log('Direct checkout: addon checkbox is checked, adding both products');
            
            // Deletion behavior is now handled globally via cart settings
            
            // Add both main product and addon product
            const addonVariantId = addonBlock.dataset.addonVariantId;
            const addonSellingPlanId = addonBlock.dataset.addonSellingPlanId;
            
            // Try reversing the order from the addon system to get wearable first
            cartItems = [
              {
                id: parseInt(variantId),
                quantity: parseInt(quantity),
                properties: this.getFormProperties(formData)
                // Don't apply selling plan to Apollo Wearable - it's not configured for it
              },
              {
                id: parseInt(addonVariantId),
                quantity: parseInt(quantity),
                selling_plan: parseInt(addonSellingPlanId) || addonSellingPlanId
              }
            ];
            
            console.log('Direct checkout: Cart items order:', [
              `1. Main product (wearable) - Variant ID: ${variantId}`,
              `2. SmartVibes addon - Variant ID: ${addonVariantId}`
            ]);
          } else {
            console.log('Direct checkout: addon not checked, adding main product only');
            // Add only main product
            cartItems = {
              id: variantId,
              quantity: parseInt(quantity),
              properties: this.getFormProperties(formData)
            };
          }
          
          // For multiple items, simulate the exact normal addon flow then redirect
          if (Array.isArray(cartItems)) {
            console.log('Direct checkout: Simulating normal addon flow then redirecting');
            
            // Get miniCart sections like the normal addon system does
            const miniCart = document.querySelector('mini-cart');
            const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];
            
            // Get addon details
            const addonVariantId = addonBlock.dataset.addonVariantId;
            const addonSellingPlanId = addonBlock.dataset.addonSellingPlanId;
            
            // Use the EXACT same order as the addon system (SmartVibes first, then main product)
            // This matches what the normal addon system sends
            const addonOrderItems = [
              {
                id: parseInt(addonVariantId),
                quantity: parseInt(quantity),
                selling_plan: parseInt(addonSellingPlanId) || addonSellingPlanId
              },
              {
                id: parseInt(variantId),
                quantity: parseInt(quantity),
                properties: this.getFormProperties(formData)
                // Don't apply selling plan to Apollo Wearable - it's not configured for it
              }
            ];
            
            console.log('Direct checkout: Using exact addon system order (SmartVibes first, main second)');
            
            // Use the same request structure as the addon system
            fetch(`${theme.routes.cart_add_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: addonOrderItems,
                sections: sections,
                sections_url: window.location.pathname
              })
            })
            .then(response => {
              if (!response.ok) {
                return response.text().then(errorText => {
                  throw new Error(JSON.parse(errorText).description || 'Cart error');
                });
              }
              return response.json();
            })
            .then(data => {
              console.log('Direct checkout: Products added with addon order, now redirecting to checkout');
              
              // Add a small delay to let any cart processing complete, then redirect
              setTimeout(() => {
                window.location.href = '/checkout';
              }, 100);
            })
            .catch(error => {
              console.error('Direct checkout error:', error);
              // Re-enable button on error
              this.submitButton.removeAttribute('disabled');
              this.submitButton.textContent = this.submitButtonText.textContent;
              // Show error message
              this.handleErrorMessage('Unable to add products to cart. Please try again.');
            });
          } else {
            // Single product - use original method
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify(cartItems)
            })
            .then(response => {
              if (!response.ok) {
                throw new Error('Failed to add to cart');
              }
              return response.json();
            })
            .then(data => {
              console.log('Direct checkout: product added to cart, redirecting to checkout');
              // Redirect to checkout immediately
              window.location.href = '/checkout';
            })
            .catch(error => {
              console.error('Direct checkout error:', error);
              // Re-enable button on error
              this.submitButton.removeAttribute('disabled');
              this.submitButton.textContent = this.submitButtonText.textContent;
              // Show error message
              this.handleErrorMessage('Unable to add product to cart. Please try again.');
            });
          }
          
          return false; // Ensure nothing else happens
        }
      }

      onSubmitHandler(evt) {
        console.log('🚨 PRODUCT FORM: onSubmitHandler called!', {
          event: evt,
          defaultPrevented: evt.defaultPrevented,
          target: evt.target,
          currentTarget: evt.currentTarget
        });
        
        // Check if direct checkout is enabled first
        const directCheckout = this.dataset.directCheckout === 'true';
        console.log('Direct checkout enabled:', directCheckout, 'Dataset value:', this.dataset.directCheckout);

        if (directCheckout) {
          // For direct checkout, completely prevent default behavior and stop all event propagation
          evt.preventDefault();
          evt.stopImmediatePropagation();
          
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
          if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) return;

          console.log('Direct checkout: bypassing normal cart flow completely');
          
          // Temporarily disable cart to prevent minicart from showing
          const originalCart = this.cart;
          this.cart = null;
          
          // Set button state but don't show loading since we're redirecting
          this.submitButton.setAttribute('aria-disabled', true);
          
          // Get form data and redirect immediately
          const formData = new FormData(this.form);
          
          // Modify the current form to redirect to checkout
          console.log('Direct checkout: modifying form action to redirect to checkout');
          
          // Store original action
          const originalAction = this.form.action;
          
          // Add return_to field to current form
          const returnInput = document.createElement('input');
          returnInput.type = 'hidden';
          returnInput.name = 'return_to';
          returnInput.value = '/checkout';
          this.form.appendChild(returnInput);
          
          // Change form action temporarily
          this.form.action = '/cart/add';
          
          // Remove the event handler temporarily to avoid recursion
          this.form.removeEventListener('submit', this.onSubmitHandler.bind(this));
          
          console.log('Direct checkout: submitting modified form');
          
          // Submit the form normally (this will trigger browser navigation)
          this.form.submit();
          
          return; // Exit completely
        }

        // Normal flow continues here
        console.log('🚨 PRODUCT FORM: Normal flow starting - preventDefault and stopPropagation called');
        evt.preventDefault();
        evt.stopPropagation();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          console.log('🚨 PRODUCT FORM: Submit button disabled, returning early');
          return;
        }
        if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) {
          console.log('🚨 PRODUCT FORM: Required fields empty, returning early');
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        //this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // Normal add to cart flow - check for addon
        const formData = new FormData(this.form);
        
        // Check if addon checkbox is checked
        const addonCheckbox = document.querySelector('input[name="addon_checkbox"]');
        const addonBlock = document.querySelector('[data-addon-variant-id]');
        
        console.log('🔍 PRODUCT FORM DEBUG:', {
          addonCheckbox: addonCheckbox,
          addonCheckboxChecked: addonCheckbox ? addonCheckbox.checked : 'N/A',
          addonBlock: addonBlock,
          addonVariantId: addonBlock ? addonBlock.dataset.addonVariantId : 'N/A',
          addonSellingPlanId: addonBlock ? addonBlock.dataset.addonSellingPlanId : 'N/A',
          formAction: this.form.action,
          formMethod: this.form.method
        });
        
        if (addonCheckbox && addonCheckbox.checked && addonBlock) {
          console.log('✅ ADDON DETECTED: Adding both products via normal form flow');
          
          // Use JSON format for multiple items
          const variantId = formData.get('id');
          const quantity = parseInt(formData.get('quantity') || '1', 10);
          const addonVariantId = addonBlock.dataset.addonVariantId;
          const addonSellingPlanId = addonBlock.dataset.addonSellingPlanId;
          
          const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];
          
          const cartItems = [
            {
              id: parseInt(addonVariantId),
              quantity: quantity,
              selling_plan: parseInt(addonSellingPlanId) || addonSellingPlanId
            },
            {
              id: parseInt(variantId),
              quantity: quantity,
              properties: this.getFormProperties(formData)
              // Don't apply selling plan to Apollo Wearable - it's not configured for it
            }
          ];
          
          console.log('📦 CART ITEMS TO ADD:', {
            cartItems: cartItems,
            sections: sections,
            url: theme.routes.cart_add_url
          });
          
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify({
            items: cartItems,
            sections: sections,
            sections_url: window.location.pathname
          });
        } else {
          console.log('❌ NO ADDON: Using single product flow');
          // Single product - use original method
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
          
          console.log('📦 SINGLE PRODUCT TO ADD:', {
            variantId: formData.get('id'),
            quantity: formData.get('quantity'),
            url: theme.routes.cart_add_url
          });
        }

        console.log('🚨 PRODUCT FORM: About to make fetch request to cart_add_url');
        
        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => {
            console.log('🚨 PRODUCT FORM: Fetch response received', {
              status: response.status,
              ok: response.ok
            });
            return response.json();
          })
          .then((response) => {
            console.log('🚨 PRODUCT FORM: Parsed response', response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = theme.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            //this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      blockSubmitIfRequiredFieldsEmpty(event) {
        if (!(this.form instanceof HTMLFormElement)) {
          throw new Error("Expected a form element.");
        }

        const formId = this.form.getAttribute('id');
        const requiredFields = document.querySelectorAll('[required]');
        let allFilled = true;
        for (const field of requiredFields) {
          const belongsToForm = (field.getAttribute('form') === formId || field.closest('form')?.id === formId);
          if (!belongsToForm) continue;
          
          let isValid = true;
          switch (field.type) {
            case 'checkbox':
            case 'radio':
              const group = document.querySelectorAll(`input[name="${field.name}"][type="${field.type}"]`);
              const isChecked = Array.from(group).some(input => input.checked);
              isValid = isChecked;
              break;
            case 'select-one':
              isValid = field.value !== '';
              break;
            case 'textarea':
            case 'text':
            case 'email':
            case 'number':
            case 'url':
            default:
              isValid = field.value.trim() !== '';
              break;
          }
          if (!isValid) {
            allFilled = false;
            field.classList.add('invalid');
          } else {
            field.classList.remove('invalid');
          }
        }
    
        if (!allFilled) {
          event.preventDefault();
          this.handleErrorMessage(theme.accessibilityStrings.fillInAllLineItemPropertyRequiredFields);
          return false;
        }
        return true;
      }

      getFormProperties(formData) {
        const properties = {};
        for (const [key, value] of formData.entries()) {
          if (key.startsWith('properties[') && key.endsWith(']')) {
            const propName = key.slice(11, -1); // Remove 'properties[' and ']'
            properties[propName] = value;
          }
        }
        return properties;
      }
      
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = theme.variantStrings.addToCart;
        }
      }

      getFormProperties(formData) {
        const properties = {};
        formData.forEach((value, key) => {
          if (key.startsWith('properties[')) {
            const propKey = key.replace('properties[', '').replace(']', '');
            properties[propKey] = value;
          }
        });
        return Object.keys(properties).length > 0 ? properties : undefined;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
